import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'

const breadcrumbMap = {
  polis: 'Verzekering'
}

const Breadcrumbs: FC<{
  breadCrumbsOverride?: {
    path: string
    label: string
  }[]
  hasPadding?: boolean
}> = ({ breadCrumbsOverride, hasPadding }) => {
  const location = useLocation()

  const pathSegments = location.pathname
    .split('/')
    .filter(Boolean)
    .filter(segment => !/^\d+$/.test(segment))

  const memoizedBreadCrumbs = useMemo(
    () =>
      pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join('/')}`

        return {
          path,
          label: `${segment.charAt(0).toUpperCase()}${segment.slice(1)}`
            .replaceAll('-', ' ')
            .replaceAll(/\d+/g, '')
            .replace(
              new RegExp(
                `\\b(${Object.keys(breadcrumbMap).join('|')})\\b`,
                'gi'
              ),
              matched =>
                breadcrumbMap[
                    matched.toLowerCase() as keyof typeof breadcrumbMap
                ]
            )
        }
      }),
    [pathSegments, document.title])

  const breadcrumbs = breadCrumbsOverride ?? memoizedBreadCrumbs

  if (breadcrumbs.length === 0) {
    return null
  }

  return (
    <div
      className={`py-4 ${hasPadding ? '' : 'px-4'}
    ${hasPadding ? '' : 'md:bg-inherit'}
    `}
    >
      <nav aria-label='breadcrumb'>
        <ol className='flex text-sm flex-wrap gap-2 items-center'>
          <li key='breadcrumb-item-home'>
            <Link to='/overzicht'>
              <FontAwesomeIcon icon={['fal', 'home']} />
            </Link>
          </li>

          <FontAwesomeIcon
            size='sm'
            icon={['fal', 'chevron-right']}
          />

          {breadcrumbs.map((crumb, index) => (
            <li
              key={`breadcrumb-item-${crumb.path}`}
              className={`breadcrumb-item ${
                index === breadcrumbs.length - 1 ? 'active' : ''
              }`}
              aria-current={
                index === breadcrumbs.length - 1 ? 'page' : undefined
              }
            >
              {index === breadcrumbs.length - 1
                ? (
                  <span className='text-text-brand'>{crumb.label}</span>
                )
                : (
                  <Link to={crumb.path}>{crumb.label}</Link>
                )}

              {index !== breadcrumbs.length - 1 && (
                <FontAwesomeIcon
                  className='ml-2'
                  size='sm'
                  icon={['fal', 'chevron-right']}
                />
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export default Breadcrumbs
